"use strict";
exports.__esModule = true;
exports.PrivilegeTypes = void 0;
var PrivilegeTypes;
(function (PrivilegeTypes) {
    PrivilegeTypes["DISPATCH_SCREEN"] = "dispatch";
    PrivilegeTypes["CREATE_ORDERS"] = "create_order";
    PrivilegeTypes["VIEW_TASK"] = "view_task";
    PrivilegeTypes["ACKNOWLEDGE_FLOW"] = "acknowledge";
    PrivilegeTypes["HISTORY"] = "history";
    PrivilegeTypes["DRIVERS"] = "drivers";
    PrivilegeTypes["DRIVER_PRORFILE"] = "driver_profile";
    PrivilegeTypes["ADD_DRIVER"] = "add_driver";
    PrivilegeTypes["CHANGE_DRIVER_ROLE"] = "change_driver_type";
    PrivilegeTypes["ASSIGN_DRIVER_TO_TASK"] = "assign_driver_to_task";
    PrivilegeTypes["TEAMS"] = "teams";
    PrivilegeTypes["USER_TYPES"] = "user_types";
    PrivilegeTypes["CUSTOMERS"] = "customers_menu";
    PrivilegeTypes["REPORTS"] = "reports";
    PrivilegeTypes["REPORTS_NEW"] = "reports_new";
    PrivilegeTypes["DASHBOARD"] = "dashboard";
    PrivilegeTypes["CASHOUT_EDIT_DISTANCE"] = "cashout_edit_distance";
    PrivilegeTypes["ACCESS_SETTINGS_SCREEN"] = "access_settings_screen";
    PrivilegeTypes["CUSTOMER_CARE"] = "customer_care";
    PrivilegeTypes["MAINTAIN_DRIVER_SHIFT_TIMES"] = "maintain_driver_shift_times";
    PrivilegeTypes["COMPLETE_TASK"] = "complete_task";
    PrivilegeTypes["EDIT_DELIVERY_BLOCK"] = "edit_delivery_block";
    PrivilegeTypes["SEE_SEND_TO_PREPARATION"] = "send_to_preparation";
    PrivilegeTypes["ACCESS_TASKS"] = "access_task";
    PrivilegeTypes["ACCESS_TO_ALL_TASKS"] = "access_to_all_tasks";
    PrivilegeTypes["ACCESS_CUSTOMER_ORDERS_ONLY"] = "access_customer_orders_only";
    PrivilegeTypes["ACCESS_COMPANY_TASKS_ONLY"] = "access_company_tasks_only";
    PrivilegeTypes["EDIT_COMPANY"] = "edit_company";
    PrivilegeTypes["ENABLE_BI_DASHBOARD"] = "enable_bi_dashboard";
    PrivilegeTypes["EDIT_EXCLUSION_WINDOWS"] = "edit_exclusion_windows";
    PrivilegeTypes["EDIT_TASK_DETAILS"] = "edit_task_details";
    PrivilegeTypes["TASKS_CSV_IMPORTER_EDIT_HEADERS"] = "tasks_csv_importer_edit_headers";
    PrivilegeTypes["EDIT_SERVICE_AREAS"] = "edit_service_areas";
    PrivilegeTypes["ACCESS_USERS"] = "access_user";
    PrivilegeTypes["ACCESS_COMPANY_USERS_ONLY"] = "access_company_users_only";
    PrivilegeTypes["ACCESS_TO_NONE_ORDERS"] = "access_to_none_orders";
    PrivilegeTypes["CANCEL_TASK"] = "cancel_task";
    PrivilegeTypes["LOCK_UNLOCK_TASK"] = "lock_unlock_task";
    PrivilegeTypes["RESCHEDULE_CANCELLED_ORDER"] = "reschedule_cancelled_order";
    PrivilegeTypes["BILLING_PORTAL"] = "billing_portal";
})(PrivilegeTypes = exports.PrivilegeTypes || (exports.PrivilegeTypes = {}));
//# sourceMappingURL=privilege.js.map